'use client';

import { usePostHogIdentification } from '@/utils/clerk/client';

export function PostHogIdentify({ children }: { children: React.ReactNode }) {
  // Identify user in PostHog when authenticated
  usePostHogIdentification();

  return <>{children}</>;
}
